import { HttpMethod, Type } from "@/Utils/request/types";

export interface PrintedDocumentEmailResponse {
  detail: string;
  correlation_id: string;
}

export default {
  send: {
    path: "/api/v1/printed_document_email/",
    method: HttpMethod.POST,
    TRes: Type<PrintedDocumentEmailResponse>(),
    TBody: Type<FormData>(),
  },
} as const;
